import React from "react";
// import { useTranslation } from "react-i18next";

// import { Form } from "antd";
// import Col from "components/shared/Col";
// import Row from "components/shared/Row";
// import SubmitButton from "components/forms/formElements/SubmitButton";
// import PartnerHeader from "./partners/PartnerHeader";

import { CONTRACT_TYPES } from "services/formService";

const ContractTypeSelector = ({ partnerToken, onSelect = () => undefined }) => {
  onSelect(CONTRACT_TYPES.BUSINESS);
  return null;
};

// const ContractTypeSelector = ({ partnerToken, onSelect = () => undefined }) => {
//   const { t } = useTranslation();

//   return (
//     <>
//       <div className="public-form">
//         <PartnerHeader partnerToken={partnerToken} />
//         <div className="public-form__form-block block">
//           <Form className="form leasing-request-form">
//             <h3 className="leasing-request-form__heading">{t("leasingFormTypeSelect")}</h3>
//             <Row className="leasing-form-selector__wrapper">
//               {/* <Col span={12} className="leasing-form-selector__submit">
//                 <SubmitButton
//                   textTranslationId={t("leasingFormTypeSelectPrivate")}
//                   onClick={() => {
//                     onSelect(CONTRACT_TYPES.PRIVATE);
//                   }}
//                 />
//               </Col> */}
//               <Col span={12} className="leasing-form-selector__submit">
//                 <SubmitButton
//                   textTranslationId={t("leasingFormTypeSelectBusiness")}
//                   onClick={() => {
//                     onSelect(CONTRACT_TYPES.BUSINESS);
//                   }}
//                 />
//               </Col>
//             </Row>
//           </Form>
//         </div>
//       </div>
//     </>
//   );
// };

export default ContractTypeSelector;
